import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useLearningStatsQueryOptions } from "@-/dev.improve.haniverse.lib.learning-stats";
import { useCallback } from "react";

function useNavigator() {
  const learningStatsPageQueryOptions = useLearningStatsQueryOptions();

  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/stats/overall",
      },
      queries: [learningStatsPageQueryOptions],
    }),
    [learningStatsPageQueryOptions],
  );
}

export const useLearningStatsOverallPageNavigator = createPageNavigator<void>({
  useNavigator,
});
